import React from 'react';
import { Toaster } from 'sonner';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { PopupLineup } from './components/PopupLineup';
import { Workshops } from './components/Workshops';
import { About } from './components/About';
import { MissionStrip } from './components/MissionStrip';
import { VendorSection } from './components/VendorSection';
import { PartnerSection } from './components/PartnerSection';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-foodCream selection:bg-foodOrange selection:text-white" data-id="element-0" data-mp="31bib1qblcqh0">
      <Toaster position="bottom-right" toastOptions={{
      style: {
        background: '#F5EFE0',
        color: '#2A1B14',
        border: '2px solid #2A1B14',
        boxShadow: '4px 4px 0px 0px #2A1B14',
        borderRadius: '0',
        fontWeight: 'bold',
        fontFamily: '"Inter", sans-serif'
      }
    }} data-id="element-1" data-mp="2wiywor52xrb5" />

      <Nav data-id="element-2" data-mp="3mkrc3gqhn9b7" />

      <main data-id="element-3" data-mp="3mk86mzi0yde2">
        <Hero data-id="element-4" data-mp="3mjzu58ptda3e" />
        <Marquee data-id="element-5" data-mp="3mjgannkimdn9" />
        <PopupLineup data-id="element-6" data-mp="3rc9du70c5dx8" />
        <Workshops data-id="element-7" data-mp="3rbrbqtqzs5he" />
        <About data-id="element-8" data-mp="3rdatkosaqola" />
        <MissionStrip data-id="element-9" data-mp="3rcswxr1q28cu" />
        <VendorSection data-id="element-10" data-mp="3reltgdimfc74" />
        <PartnerSection data-id="element-11" data-mp="5os92t1uy7l" />
        <Newsletter data-id="element-12" data-mp="4wxfu7a14id" />
      </main>

      <Footer data-id="element-13" data-mp="82lr78302d1" />
    </div>;
}